import { ascend, descend, prop, propEq, sort } from 'ramda'
import { useMemo } from 'react'

import { useLevelsState } from '../_load/LevelsLoader'

export const useEnabledLevels = () => {
  const { levels } = useLevelsState()
  return useMemo(() => levels.filter(propEq('enabled', true)), [levels])
}

export const useSortedEnabledLevels = () => {
  const levels = useEnabledLevels()
  return useMemo(() => sort(descend(prop('id')), levels), [levels])
}

export const useAscEnabledLevels = () => {
  const levels = useEnabledLevels()
  return useMemo(() => sort(ascend(prop('id')), levels), [levels])
}

export const useAscSortedLevels = () => {
  const { levels } = useLevelsState()
  return useMemo(() => sort(ascend(prop('id')), levels), [levels])
}
